<template>
  <div>
    <v-container class="pb-0">
      <v-row class="my-0 mb-2">
        <v-col v-if="!companyScoped" cols="3" class="py-0 pr-1">
          <v-select
            :background-color="filters.company ? 'serenade' : ''"
            v-model="filters.company"
            :items="companies"
            :loading="companiesLoading"
            :disabled="companiesLoading"
            item-text="title"
            item-value="id"
            dense
            hide-details
            outlined
            clearable
            :placeholder="'company'|localize"
            :menu-props="{ offsetY: true, bottom: true }"
          >
            <template v-slot:item="{ item, on }">
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </template>
            <template v-slot:selection="{ item, index }">
              <div class="d-flex">
                <span v-if="index === 0" class="text-truncate" style="max-width: 100px">{{ item.title }}</span>
                <span v-if="index === 1" class="grey--text text-caption">+{{ filters.company.length - 1 }}</span>
              </div>
            </template>
          </v-select>
        </v-col>
        <v-col cols="3" class="py-0">
          <v-row class="my-0">
            <v-col cols="6" class="py-0 px-1">
              <v-menu
                ref="menuDateFrom"
                v-model="menuDateFrom"
                :close-on-content-click="false"
                :return-value.sync="filters.dateFrom"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :background-color="filters.dateFrom ? 'serenade' : ''"
                    :placeholder="'dateFrom' | localize"
                    :value="filters.dateFrom"
                    readonly
                    dense
                    hide-details
                    outlined
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="filters.dateFrom"
                  no-title
                  scrollable
                  @input="$refs.menuDateFrom.save(filters.dateFrom)"
                />
              </v-menu>
            </v-col>
            <v-col cols="6" class="py-0 px-1">
              <v-menu
                ref="menuDateTo"
                v-model="menuDateTo"
                :close-on-content-click="false"
                :return-value.sync="filters.dateTo"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :background-color="filters.dateTo ? 'serenade' : ''"
                    :placeholder="'dateTo' | localize"
                    :value="filters.dateTo"
                    readonly
                    dense
                    hide-details
                    outlined
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="filters.dateTo"
                  no-title
                  scrollable
                  @input="$refs.menuDateTo.save(filters.dateTo)"
                />
              </v-menu>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="3" class="py-0 px-1">
          <v-autocomplete
            :background-color="filters.country_from.length ? 'serenade' : ''"
            v-model="filters.country_from"
            :items="COUNTRY_LIST"
            :item-text="item => `${item.name} ${item.code}`"
            :item-value="item => `${item.code}`"
            dense
            hide-details
            outlined
            :placeholder="'countryFrom'|localize"
            clearable
            multiple
            attach
          >
            <template v-slot:item="{ item, on }">
              <v-list-item-title>{{ item.name }} ({{item.code}})</v-list-item-title>
            </template>
            <template v-slot:selection="{ item, index }">
              <span v-if="index === 0" class="text-truncate mr-1" style="max-width: 100px">{{ item.name }}</span>
              <span v-if="index === 1" class="grey--text text-caption mr-1">+{{ filters.country_from.length - 1 }}</span>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="3" class="py-0 pl-1">
          <v-autocomplete
            :background-color="filters.country_to.length ? 'serenade' : ''"
            v-model="filters.country_to"
            :items="COUNTRY_LIST"
            :item-text="item => `${item.name} ${item.code}`"
            :item-value="item => `${item.code}`"
            dense
            hide-details
            outlined
            :placeholder="'countryTo'|localize"
            clearable
            multiple
            attach
          >
            <template v-slot:item="{ item, on }">
              <v-list-item-title>{{ item.name }} ({{item.code}})</v-list-item-title>
            </template>
            <template v-slot:selection="{ item, index }">
              <span v-if="index === 0" class="text-truncate mr-1" style="max-width: 100px">{{ item.name }}</span>
              <span v-if="index === 1" class="grey--text text-caption mr-1">+{{ filters.country_to.length - 1 }}</span>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
    </v-container>
    <QuotedAboveBooked :companies='companies' :companiesLoading='companiesLoading' :filters="filters" :companyScoped='companyScoped'/>
    <QuotedBelowBooked :companies='companies' :companiesLoading='companiesLoading' :filters="filters" :companyScoped='companyScoped'/>
    <TransportModeComparison :companies='companies' :companiesLoading='companiesLoading' :filters="filters" :companyScoped='companyScoped'/>
    <QuotedAboveTarget :companies='companies' :companiesLoading='companiesLoading' :filters="filters" :companyScoped='companyScoped'/>
  </div>
</template>

<script>
  import QuotedAboveBooked from '@/components/QuotedAboveBooked.vue';
  import QuotedBelowBooked from '@/components/QuotedBelowBooked.vue';
  import QuotedAboveTarget from '@/components/QuotedAboveTarget.vue';
  import TransportModeComparison from '@/components/TransportModeComparison.vue';
  import methods from '@/helpers/methods';

  export default {
    name: 'AdminNotBookedReports',
    components: {TransportModeComparison, QuotedAboveTarget, QuotedBelowBooked, QuotedAboveBooked},
    props: ['companies', 'companiesLoading', 'companyScoped'],
    data() {
      return {
        menuDateFrom: false,
        menuDateTo: false,
        filters: {
          dateFrom: methods.yearAgoDate(),
          dateTo: methods.todayDate(),
          company: null,
          country_from: [],
          country_to: [],
        },
      };
    },
    computed: {
      COUNTRY_LIST() {
        return this.$store.getters.countries;
      },
    },
  };
</script>
